import { apiFetch } from "./api";


// GET - Obtener todos los servicios
export const getServices = async () => {
  const res = await apiFetch('/services');

  if (!res.ok) {
    throw new Error("Error al obtener servicios");
  }

  return await res.json();
};

// GET - Obtener servicio específico
export const getService = async (id) => {
  const res = await apiFetch(`/services/${id}`);

  if (!res.ok) {
    throw new Error("Error al obtener el servicio");
  }

  return await res.json();
};

// POST - Crear service
export const createService = async (formData) => {
  const res = await apiFetch('/services', {
    method: "POST",
    body: formData,
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.message || "Error al crear el servicio");
  }

  return data;
};


// PUT - Actualizar servicio
export const updateServicio = async (id, formData) => {
  const res = await apiFetch(`/services-update/${id}`, {
    method: "POST", // Laravel usa POST con _method=PUT para FormData
    body: formData,
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.message || "Error al actualizar el servicio");
  }

  return data;
};

// DELETE
export const deleteService = async (id) => {
  const res = await apiFetch(`/services/${id}`, {
    method: "DELETE",
  });

  if (!res.ok) {
    const data = await res.json();
    throw new Error(data.message || "Error al eliminar");
  }

  return { success: true };
};
//RESET Services
export const resetServices = async () => {
  const res = await apiFetch('/services-reset', {
    method: "POST",
  });

  if (!res.ok) {
    const data = await res.json();
    throw new Error(data.message || "Error al resetear servicios");
  }

  return { success: true };
}

